import ReactDOM from 'react-dom/client';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import { kooperativaTheme, komunalnaTheme, useGlobalStyles, SnackbarProvider, TooltipProvider } from 'vig-ui-library';
import reportWebVitals from './reportWebVitals';
import App from '@/App';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { skSK } from "@mui/x-date-pickers/locales";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/sk';
import { companyType, isPublicApp } from '@/Utils/environment';
import { CompanyType } from '@/Enums/CompanyType';
import { ThemeProvider as RequestFormThemeProvider, CompanyType as RequestFormCompanyType } from 'request-form-lib';

const appTheme = companyType === CompanyType.KOMUNALNA ? komunalnaTheme : kooperativaTheme;

const requestFormCompanyType = companyType === CompanyType.KOMUNALNA
  ? RequestFormCompanyType.KOMUNALNA
  : RequestFormCompanyType.KOOPERATIVA;

const appContent = (
  <LocalizationProvider
    dateAdapter={AdapterDayjs}
    adapterLocale="sk"
    localeText={skSK.components.MuiLocalizationProvider.defaultProps.localeText}
  >
    <SnackbarProvider>
      <TooltipProvider>
        <App />
      </TooltipProvider>
    </SnackbarProvider>
  </LocalizationProvider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  isPublicApp ? (
    <RequestFormThemeProvider companyType={requestFormCompanyType}>
      {appContent}
    </RequestFormThemeProvider>
  ) : (
    <ThemeProvider theme={appTheme}>
      <GlobalStyles styles={useGlobalStyles(appTheme)} />
      <CssBaseline />
      {appContent}
    </ThemeProvider>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();